import { r } from './index-DM5rHkdJ.js'
import { g as i } from './media-queries-CokWIw5y.js'
import { a as s } from './at-breakpoint-change-DVsQWIFj.js'
import { C as a } from './carousel-B31DfJo9.js'
import { P as n } from './product-item-Du4jXRmW.js'
import { i as m } from './intersection-watcher-D3vtB7Co.js'
import { d as c } from './delay-offset-DYAL33nW.js'
import { s as d } from './shouldAnimate-BMbjctYf.js'
import './fluorescent-dom.es-Cu7dY8l0.js'
import './evx.es-D_-Lbk8t.js'
import './cart-Dp1qr_mc.js'
import './storage-CVUx8WVm.js'
const o = { intro: '.animation--section-introduction > *', items: '.animation--item' },
  h = (e) => {
    c(e, [o.intro, o.items])
    const t = m(e)
    return {
      destroy() {
        t == null || t.destroy()
      },
    }
  }
r('featured-collection-grid', {
  onLoad() {
    const { productsPerView: e, mobileProductsPerView: t } = this.container.dataset
    ;((this.events = []),
      (this.perView = parseInt(e, 10)),
      (this.mobilePerView = parseInt(t, 10) * 1.05),
      (this.productItem = n(this.container)),
      (this.breakPointHandler = s(960, () => {
        window.matchMedia(i('below-960')).matches ? this._initCarousel() : this.carousel.destroy()
      })),
      window.matchMedia(i('below-960')).matches && this._initCarousel(),
      d(this.container) && (this.animateFeaturedCollectionGrid = h(this.container)))
  },
  _initCarousel() {
    this.carousel = a(this.container, {
      slidesPerView: this.mobilePerView,
      spaceBetween: 12,
      breakpoints: { 720: { spaceBetween: 16, slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView } },
    })
  },
  onUnload() {
    var e, t
    ;((e = this.carousel) == null || e.destroy(), (t = this.animateFeaturedCollectionGrid) == null || t.destroy())
  },
})
